import { getCanvasCoord, subtractCoordinates } from '../../utils/utils.js'

/**
 * 도형 그리기 중 (마우스/터치 이동)
 * - delta 계산을 바탕으로 path 모양과 위치 갱신
 */
export const handleShapeMove = (state) => {
  const {
    paths,
    currentPath,
    currentPathId,
    scope,
    translate,
    clientCoord,
    // [동시편집]
    triggerUpdatePath,
  } = state

  // 현재 좌표 계산
  const canvasCoord = getCanvasCoord(clientCoord, translate, scope)
  let delta = subtractCoordinates(canvasCoord, currentPath.current)

  let cx, cy, rx, ry
  const lastPath = paths[currentPathId.current]

  lastPath.minX = Math.min(0, delta.x)
  lastPath.maxX = Math.max(0, delta.x)
  lastPath.minY = Math.min(0, delta.y)
  lastPath.maxY = Math.max(0, delta.y)
  // if (delta.x >= 0) {
  //   lastPath.minX = 0
  //   lastPath.maxX = delta.x
  // } else {
  //   lastPath.minX = delta.x
  //   lastPath.maxX = 0
  // }

  // if (delta.y >= 0) {
  //   lastPath.minY = 0
  //   lastPath.maxY = delta.y
  // } else {
  //   lastPath.minY = delta.y
  //   lastPath.maxY = 0
  // }

  if (lastPath.type === 'square' || lastPath.type === 'line') {
    lastPath.w = lastPath.maxX - lastPath.minX
    lastPath.h = lastPath.maxY - lastPath.minY
    lastPath.aspectRatio = lastPath.h / lastPath.w

    if (lastPath.type === 'square') {
      lastPath.d = `M 0 0 L ${delta.x} 0 L ${delta.x} ${delta.y} L 0 ${delta.y} Z`
    } else {
      lastPath.d = `M 0 0 L ${delta.x} ${delta.y} Z`
    }
  } else if (lastPath.type === 'circle') {
    cx = delta.x / 2
    cy = delta.y / 2
    rx = Math.abs(delta.x) / 2 // x축 반지름
    ry = Math.abs(delta.y) / 2 // y축 반지름

    lastPath.d = `M ${cx - rx}, ${cy}
    a ${rx},${ry} 0 1,0 ${2 * rx},0
    a ${rx},${ry} 0 1,0 ${-2 * rx},0`
  } else if (lastPath.type === 'triangle') {
    lastPath.d = `M 0 ${delta.y} L ${delta.x / 2} 0 L ${delta.x} ${delta.y} Z`
  } else {
    console.warn('shape move error')
  }
  // lastPath.d =
  //   lastPath.type === 'square'
  //     ? `M 0 0 L ${delta.x} 0 L ${delta.x} ${delta.y} L 0 ${delta.y} Z`
  //     : lastPath.type === 'circle'
  //     ? `M ${cx - rx}, ${cy}
  //       a ${rx},${ry} 0 1,0 ${2 * rx},0
  //       a ${rx},${ry} 0 1,0 ${-2 * rx},0`
  //     : lastPath.type === 'triangle'
  //     ? `M 0 ${delta.y} L ${delta.x / 2} 0 L ${delta.x} ${delta.y} Z`
  //     : `M 0 0 L ${delta.x} ${delta.y} Z`

  triggerUpdatePath(currentPathId.current, lastPath, 'no-op')
}
